import React, { createContext, useState } from "react";
import { ActionName } from "types/common";

type ModalContextType = {
  modalType: any;
  setModalType: any;
  showProjects: boolean;
  setShowProjects: React.Dispatch<React.SetStateAction<boolean>>;
  showKeyGuide: boolean;
  setShowKeyGuide: React.Dispatch<React.SetStateAction<boolean>>;
  initialSettingsTab: any;
  setInitialSettingsTab: any;
  showHealth: boolean;
  setShowHealth: React.Dispatch<React.SetStateAction<boolean>>;
};

export const ModalContext = createContext<ModalContextType>({
  modalType: '',
  setModalType: () => { },
  showProjects: false,
  setShowProjects: () => { },
  showKeyGuide: false,
  setShowKeyGuide: () => { },
  initialSettingsTab: null,
  setInitialSettingsTab: () => { },
  showHealth: false,
  setShowHealth: () => { },
});

const ModalProvider = ({ children }: { children: React.ReactNode }) => {
  const [modalType, setModalType] = useState<ActionName | ''>('');
  const [showProjects, setShowProjects] = useState<boolean>(false);
  const [showKeyGuide, setShowKeyGuide] = useState<boolean>(false);
  const [initialSettingsTab, setInitialSettingsTab] = useState<number | undefined>(undefined);
  const [showHealth, setShowHealth] = useState(false);

  return (
    <ModalContext.Provider value={{
      modalType,
      setModalType,
      showProjects,
      setShowProjects,
      showKeyGuide,
      setShowKeyGuide,
      initialSettingsTab,
      setInitialSettingsTab,
      showHealth,
      setShowHealth
    }}>
      {children}
    </ModalContext.Provider>
  );
};

export default ModalProvider;
